// extracted by mini-css-extract-plugin
module.exports = {"mypage_subsc_foot_buttons":"footer_mypage_subsc_foot_buttons__3Gnc3"};